import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Layout from "../components/Layout";
import AuthLayoutWithoutSidebar from "components/Layout/AuthLayOutWithoutSidebar";

const AuthMiddleware = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("authUser");


  const layoutExcludedRoutes = [
    "/subscription",
    "/welcome-message",
    "/orgnisation-details",
    "/redirectUrl",
    "/plan-picker",
  ];
  const shouldExcludeLayout = layoutExcludedRoutes.includes(location.pathname);

  if (shouldExcludeLayout && isAuthenticated) {
    return <AuthLayoutWithoutSidebar>{children}</AuthLayoutWithoutSidebar>;
  }


  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Layout>{children}</Layout>;
};

export default AuthMiddleware;
